<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo" style="width: 90% !important;">
            <div class="contenedor_modal_cabecera">
                <button type="button" class="btn btn-sm btn-outline-danger" @click="cerrar"><i
                        class="fas fa-times"></i></button>
            </div>
            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-2">
                        <h3>
                            Detalle de factura
                        </h3>
                    </div>
                    <div class="col-sm-12 mt-2">
                        Serie: {{ objeto.sat_serie }} <br>
                        Número: {{ objeto.sat_numero }} <br>
                        NIT: {{ objeto.nit_cliente }}
                    </div>
                    <div class="col-sm-12 mt-3">

                        <table class="table table-sm table-striped table-bordered" style="font-size: 12px;">
                            <thead>
                                <tr>
                                    <th style="text-align: center;width: 15%">
                                        Código
                                    </th>
                                    <th style="width: 30%">
                                        Nombre
                                    </th>
                                    <th style="text-align: center;width: 10%">
                                        Fecha
                                    </th>
                                    <th style="text-align: center;width: 5%">
                                        Cantidad
                                    </th>
                                    <th style="text-align: center;width: 10%">
                                        P.Unitario
                                    </th>
                                    <th style="text-align: center;width: 10%">
                                        Subtotal
                                    </th>
                                    <th style="text-align: center;width: 10%">
                                        Decuento
                                    </th>
                                    <th style="text-align: center;width: 10%">
                                        Total C/Desc
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(item, index) in registros" :key="index">
                                    <td style="text-align:center;">
                                        {{ item.codigo }}
                                    </td>
                                    <td>
                                        {{ item.nombre_articulo }}
                                    </td>
                                    <td style="text-align:center;">
                                        {{ item.fecha_movimiento }}
                                    </td>
                                    <td style="text-align:center;">
                                        {{ Math.abs(item.cantidad) }}
                                    </td>
                                    <td style="text-align:center;">
                                        Q{{ item.precio.toLocaleString(undefined, {
                                            minimumFractionDigits: 2, maximumFractionDigits: 2
                                        }) }}
                                    </td>
                                    <td style="text-align:center;">
                                        Q{{ (Math.abs(item.cantidad) * item.precio).toLocaleString(undefined, {
                                            minimumFractionDigits: 2, maximumFractionDigits: 2
                                        }) }}
                                    </td>
                                    <td style="text-align:center;">
                                        Q{{ item.descuento.toLocaleString(undefined, {
                                            minimumFractionDigits: 2, maximumFractionDigits: 2
                                        }) }}
                                    </td>
                                    <td style="text-align:center;">
                                        Q{{ ((Math.abs(item.cantidad) * item.precio) -
                                            item.descuento).toLocaleString(undefined, {
                                                minimumFractionDigits: 2, maximumFractionDigits: 2
                                            }) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'ModalDetalleFactura',
        props: ['objeto'],
        data() {
            return {
                registros: [],
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir');
            },
            async obtener_registros() {
                let f = {
                    api: `movimientos-detalles/c/movimientos_por_id?idd=${this.objeto.document_id}&empresa=${this.objeto.empresa}`,
                }

                let r = await this.obtener_data(f);
                this.registros = r;
            },
            ...mapActions(['obtener_data'])
        },
        mounted() {
            this.obtener_registros();
        }
    }

</script>

<style></style>